<template>
  <div class="w-full h-full pt-4 pb-5 box-border flex bg-white overflow-hidden" v-loading="loading">
    <div class="flex-1 px-10 box-border overflow-hidden">
      <p class="w-full text-medium text-theme-black-650 leading-22">企业名称</p>
      <p class="w-full mt-1 text-large text-theme-black-850 leading-22 font-bold truncate">
        <el-tooltip :content="companyName" placement="bottom-start">
          <span>{{ companyName || '—' }}</span>
        </el-tooltip>
      </p>
    </div>
    <div class="w-px h-full border-r border-solid border-border-gray" />
    <div class="flex-1 px-10 box-border overflow-hidden">
      <p class="w-full flex items-center">
        <span class="text-medium text-theme-black-650 mr-1" :class="adjustYuanAmount != 0 ? 'leading-none' : 'leading-22'"
          >结算总费用(元)</span
        >
        <el-tooltip content="代理的结算总费用">
          <i class="iconfont icon-shuoming text-medium text-theme-black-350 cursor-pointer"></i>
        </el-tooltip>
      </p>
      <p class="my-1 text-large-x text-theme-black-850 leading-22 font-bold font-DINA">
        {{ operationalYuanAmount | formatPrice }}
      </p>
      <p class="w-full flex items-center" v-if="adjustYuanAmount != 0">
        <span class="text-small text-yellow-theme leading-none mr-1"> 含补扣款 {{ adjustYuanAmount | formatPrice }} </span>
        <el-tooltip content="根据调查实际情况，给代理补扣相应款项，补扣款将计入代理结算总费用">
          <i class="iconfont icon-shuoming text-medium text-theme-black-350 cursor-pointer"></i>
        </el-tooltip>
      </p>
    </div>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { filtersMixins } from '@/mixins/relate-settlement'
import { statisticsDetail } from '@/api/cost-settlement/common'

export default {
  name: 'UndertakeStatistics',
  mixins: [filtersMixins],
  props: {
    statementId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      companyName: GlobalConfig.getCompanyName(),
      adjustYuanAmount: 0,
      operationalYuanAmount: 0,
      loading: false
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      if (this.statementId) {
        this.loading = true
        statisticsDetail(this.statementId)
          .then(res => {
            const { code, msg, data } = res.data
            if (code == 0) {
              this.adjustYuanAmount = data?.adjustYuanAmount ?? 0
              this.operationalYuanAmount = data?.operationalYuanAmount ?? 0
            } else {
              this.$message.error(msg ?? '获取企业信息失败')
            }
          })
          .catch(() => {
            this.$message.error('获取企业信息失败')
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
